module.exports = __webpack_public_path__ + "img/left-arm.fefde343.svg";